import React from 'react';
import type { OperationDefinitionDto, OperationRunDto } from '../../types';
import { formatDateTime, formatDuration, statusLabel, triggerLabel } from './utils.tsx';

interface Props {
    definitions: OperationDefinitionDto[];
    journalRuns: OperationRunDto[];
    journalFilterOp: string;
    journalFilterStatus: string;
    setJournalFilterOp: (value: string) => void;
    setJournalFilterStatus: (value: string) => void;
    onApplyFilters: () => Promise<void>;
    onSelectJournalRun: (runId: number) => Promise<void>;
}

const OperationsJournalPanel: React.FC<Props> = ({
    definitions,
    journalRuns,
    journalFilterOp,
    journalFilterStatus,
    setJournalFilterOp,
    setJournalFilterStatus,
    onApplyFilters,
    onSelectJournalRun
}) => (
    <>
        <div className="operations-journal-filters">
            <div className="form-group-custom">
                <label className="form-label-custom">Операция</label>
                <select
                    className="form-select-custom"
                    value={journalFilterOp}
                    onChange={e => setJournalFilterOp(e.target.value)}
                >
                    <option value="">Все</option>
                    {definitions.map(def => (
                        <option key={def.code} value={def.code}>{def.title}</option>
                    ))}
                </select>
            </div>
            <div className="form-group-custom">
                <label className="form-label-custom">Статус</label>
                <select
                    className="form-select-custom"
                    value={journalFilterStatus}
                    onChange={e => setJournalFilterStatus(e.target.value)}
                >
                    <option value="">Все</option>
                    <option value="Queued">В очереди</option>
                    <option value="Running">Выполняется</option>
                    <option value="Succeeded">Успешно</option>
                    <option value="Failed">Ошибка</option>
                </select>
            </div>
            <button
                className="btn btn-primary-custom"
                onClick={onApplyFilters}
                style={{ alignSelf: 'flex-end' }}
            >
                <i className="bi bi-search"></i>
                Применить
            </button>
        </div>

        {journalRuns.length > 0 ? (
            <div className="operations-table-wrap">
                <table className="table table-hover">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Операция</th>
                            <th>Статус</th>
                            <th>Триггер</th>
                            <th>Запустил</th>
                            <th>Запущено</th>
                            <th>Длительность</th>
                        </tr>
                    </thead>
                    <tbody>
                        {journalRuns.map(run => (
                            <tr
                                key={run.id}
                                onClick={async () => {
                                    await onSelectJournalRun(run.id);
                                }}
                            >
                                <td>{run.id}</td>
                                <td>{run.operationTitle}</td>
                                <td>
                                    <span className={`operations-status status-${run.status.toLowerCase()}`}>
                                        {statusLabel[run.status] ?? run.status}
                                    </span>
                                </td>
                                <td>{triggerLabel[run.trigger] ?? run.trigger}</td>
                                <td>{run.requestedByUserName ?? '-'}</td>
                                <td>{formatDateTime(run.createdAt)}</td>
                                <td>{formatDuration(run)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        ) : (
            <div className="operations-empty">Запусков по вашему запросу не найдено.</div>
        )}
    </>
);

export default OperationsJournalPanel;
